/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_EmailInputs */

const vi_order_form_invoice_buyer_email = /** @type {(inputs: Order_Form_Invoice_Buyer_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email người nhận hóa đơn`)
};

/**

* @param {Order_Form_Invoice_Buyer_EmailInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_email = /** @type {((inputs?: Order_Form_Invoice_Buyer_EmailInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_EmailInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_email(inputs)
});